import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useCriteriaUIStore = create(
  persist(
    (set) => ({
      pageValue: 0,
      setPageValue: (v) => set({ pageValue: v }),

      activePreview: true,
      setActivePreview: (v) => set({ activePreview: v }),

      activePageBar: false,
      setActivePageBar: (v) => set({ activePageBar: v }),

      disableTabs: true,
      setDisableTabs: (v) => set({ disableTabs: v }),

      activeTabBar: true,
      setActiveTabBar: (v) => set({ activeTabBar: v }),

      hideTabs: false,
      setHideTabs: (v) => set({ hideTabs: v }),

      tabValue: "1",
      setTabValue: (v) => set({ tabValue: v }),

      tabTouched: [],
      setTabTouched: (v) => set({ tabTouched: v }),

      blurOverlay: false,
      setBlurOverlay: (v) => set({ blurOverlay: v }),

      ageHint: false,
      setAgeHint: (v) => set({ ageHint: v }),

      ageHintFinished: false,
      setAgeHintFinished: (v) => set({ ageHintFinished: v }),

      ageHintAppear: false,
      setAgeHintAppear: (v) => set({ ageHintAppear: v }),

      ageHintAppearFinished: false,
      setAgeHintAppearFinished: (v) => set({ ageHintAppearFinished: v }),

      tabHint: false,
      setTabHint: (v) => set({ tabHint: v }),

      tabTwoHintFinished: false,
      setTabTwoHintFinished: (v) => set({ tabTwoHintFinished: v }),

      heightHint: false,
      setHeightHint: (v) => set({ heightHint: v }),

      heightHintAppearFinished: false,
      setHeightHintFinished: (v) => set({ heightHintFinished: v }),

      raceHint: false,
      setRaceHint: (v) => set({ raceHint: v }),

      raceHintAppearFinished: false,
      setRaceHintFinished: (v) => set({ raceHintFinished: v }),


    }),
    {
      name: "ui-criteria-storage",
    }
  )
);



export const useEstimatesUIStore = create(
  persist(
    (set) => ({
      estimatesPageAppear: false,
      setEstimatesPageAppear: (v) => set({ estimatesPageAppear: v }),

      estimatesPageAppearFinished: false,
      setEstimatesPageAppearFinished: (v) => set({ estimatesPageAppearFinished: v }),

      estimatesHintFinished: false,
      setEstimatesHintFinished: (v) => set({ estimatesHintFinished: v }),

      estimatesHintAppear: true,
      setEstimatesHintAppear: (v) => set({ estimatesHintAppear: v }),

      showAdditionalCriteria: false,
      setShowAdditionalCriteria: (v) => set({ showAdditionalCriteria: v }),

      returnToFoundationalCriteria: false,
      setReturnToFoundationalCriteria: (v) => set({ returnToFoundationalCriteria: v }),

      estimatesAppear: false,
      setEstimatesAppear: (v) => set({ estimatesAppear: v }),

      currentEstimatesDialogueStep: 0,
      setCurrentEstimatesDialogueStep: (v) => set({ currentEstimatesDialogueStep: v }),

      estimatesFinishedAppearHint: false,
      setEstimatesFinishedAppearHint: (v) => set({ estimatesFinishedAppearHint: v }),

      estimatesFinishedHintFinished: false,
      setEstimatesFinishedHintFinished: (v) => set({ estimatesFinishedHintFinished: v }),

      estimatesZeroAppearHint: false,
      setEstimatesZeroAppearHint: (v) => set({ estimatesZeroAppearHint: v }),

      estimatesZeroHintFinished: false,
      setEstimatesZeroHintFinished: (v) => set({ estimatesZeroHintFinished: v }),
    }),
    {
      name: "estimates-ui-storage",
    }
  )
);


export const usePlanUIStore = create(
  persist(
    (set) => ({
      activePlanDrawer: null,
      setActivePlanDrawer: (v) => set({ activePlanDrawer: v }),

    }),
    {
      name: "plan-ui-storage",
    }
  )
);